import './BlogPostCard.scss';

import { Post } from '@travelwin/cms/types';
import { ButtonV2 } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import { ImageMedia } from '../ImageMedia';
import { Link } from '../Link';

const className = 'c-BlogPostCard';

type BlogPostCardProps = {
  image: Post['mainImage'];
  title: string;
  summary: string;
  link: string;
};

export const BlogPostCard = ({
  image,
  title,
  summary,
  link,
}: BlogPostCardProps) => {
  const { t } = useTranslation();

  return (
    <article className={className}>
      <ImageMedia
        media={image}
        className={`${className}__image`}
        // 380px is declared as the max width for the blog post card
        // 32px is 16px twice for the general page padding
        // 48px is 24px twice for the blog post page padding
        sizes="(max-width: 380px) calc(100vw - 32px - 48px), 380px"
        loading="lazy"
      />
      <Link className={`${className}__link`} to={link}>
        {title}
      </Link>
      <p className={`${className}__summary`}>{summary}</p>
      <ButtonV2 asChild variant="secondary" size="large">
        <Link to={link}>{t('landing.read_more', 'Read More')}</Link>
      </ButtonV2>
    </article>
  );
};

export default BlogPostCard;
